import { ImageUtils } from './../../../helper/image-utils';
import { PartnerModel } from './../../../../module/partner/model/partner.model';
import { PartnerService } from './../../../../module/partner/partner.service';
import {
    Component,
    Input,
    ViewChild,
    TemplateRef,
    ElementRef,
    ViewContainerRef,
    Output,
    EventEmitter, OnInit, OnChanges, SimpleChanges
} from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { PaginatedModel } from '../pagination/model/paginated.model';

@Component({
    selector: 'app-partner-select',
    templateUrl: './partner-select.component.html',
    styleUrl: './partner-select.component.scss'
})
export class PartnerSelectComponent implements OnInit, OnChanges {
    @Input() label: string = '';
    @Input() icon = 'uii-partner';
    @Input() readonly: boolean = false;
    @Input() viewMode: 'select' | 'badges' = 'select';
    @Input() selectedPartnerId: string | undefined = undefined;
    @Input() emitOnInit = true;
    @Input() partnerFilter: 'all' | 'patients' = 'all';
    @Input() loading = false;

    @Output() changed = new EventEmitter<PartnerModel>();

    @ViewChild('trigger') trigger!: ElementRef;
    @ViewChild('dropdownTemplate') menuTemplate!: TemplateRef<any>;

    overlayRef!: OverlayRef;

    isEditing = true;
    partnerFilterValue: string = '';
    partners: Array<PartnerModel> = [];
    selectedPartner: PartnerModel | null = null;
    request: Subscription = new Subscription();
    searching = true;

    get isLoading(): boolean {
        return this.loading || this.searching;
    }

    constructor(
        protected partnerService: PartnerService,
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef
    ) {}

    public ngOnInit(): void {
        if (!this.readonly) {
            this.searchPartners();
        } else {
            this.searching = false;
        }
    }
    public ngOnChanges(changes: SimpleChanges): void {
        this.initializePartner();
    }
    protected initializePartner(): void {
        if (this.selectedPartnerId) {
            this.partnerService.getPartner(this.selectedPartnerId).subscribe((partner: PartnerModel) => {
                this.selectedPartner = partner;
                this.selectedPartner.logoSrc = this.renderLogo(partner.logo);
                if (this.emitOnInit) {
                    this.changed.emit(this.selectedPartner);
                }
            });
        } else {
            this.selectedPartner = null;
        }
    }
    public eventOpenOptions(): void {
        if (this.isLoading) {
            return;
        }
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(this.trigger)
            .withPositions([
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top',
                    offsetY: 8,
                }
            ]);

        const triggerWidth = this.trigger.nativeElement.getBoundingClientRect().width;
        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            width: triggerWidth,
            minWidth: triggerWidth,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.reposition()
        });

        this.overlayRef.backdropClick().subscribe(() => { this.overlayRef.dispose();});

        const menuTemplateBuilt = new TemplatePortal(this.menuTemplate, this.viewContainerRef);

        this.overlayRef.attach(menuTemplateBuilt);
    }

    private renderLogo(logo: string) {
        return ImageUtils.convertValueToImg(logo);
    }
    protected handlePartners(partners: PaginatedModel<PartnerModel>): void {
        this.partners = partners.items.map(elem => ({
            ...elem,
            logoSrc: this.renderLogo(elem.logo)
        }));

        if (this.selectedPartner) {
            const havePartner = this.partners.find((partner) => partner._id === this.selectedPartner?._id);
            if (!havePartner) {
                this.partners.unshift(this.selectedPartner);
            }
        }

    }
    public eventPartnerChanged(partner: PartnerModel): void {
        if (partner._id === this.selectedPartner?._id) {
            this.selectedPartner = null;
        } else {
            this.selectedPartner = partner;
        }
        this.isEditing = false;
        this.changed.emit(this.selectedPartner as any);

        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }

    public eventPartnerFilterChange(value: Event): void {
        this.partnerFilterValue = (value.target as HTMLInputElement).value;
        this.searchPartnersByFilter(this.partnerFilterValue);
    }

    protected searchPartners(): void {
        this.request.unsubscribe();
        this.searchPartnersByFilter('');
    }

    protected searchPartnersByFilter(filter: string): void {
        this.request.unsubscribe();
        this.searching = true;

        this.request = this.partnerService.getPartners(filter, 1, 10, [], 'ACTIVE')
            .pipe(debounceTime(600), distinctUntilChanged())
            .subscribe((partners) => {
                this.searching = false;
                this.handlePartners(partners);
            });
    }
}
